module.exports = __webpack_public_path__ + "static/media/references-allianz.bbec24f9.png";